
// Search Translation
export const SEARCH_SET_TRANSLATION_ENABLED = "SEARCH_SET_TRANSLATION_ENABLED";
export const SEARCH_SET_FULL_TRANSLATION_ENABLED = "SEARCH_SET_FULL_TRANSLATION_ENABLED";
export const SEARCH_SET_TRANSLATION_LANGUAGES = "SEARCH_SET_TRANSLATION_LANGUAGES";
export const SEARCH_ACTIVATE_TRANSLATION_OPTIONS = "SEARCH_ACTIVATE_TRANSLATION_OPTIONS";
export const SEARCH_SET_SHOW_EXPANDED_QUERY = "SEARCH_SET_SHOW_EXPANDED_QUERY";
export const SEARCH_RESET_EXPANDED_QUERY = "SEARCH_RESET_EXPANDED_QUERY";
export const SEARCH_SET_EXPANDED_QUERY = "SEARCH_SET_EXPANDED_QUERY";
export const SEARCH_SET_EXPANDED_QUERY_LOADING = "SEARCH_SET_EXPANDED_QUERY_LOADING";
export const SEARCH_SET_ACTIVE_EXPANDED_QUERY = "SEARCH_SET_ACTIVE_EXPANDED_QUERY";
export const SEARCH_RESET_ACTIVE_EXPANDED_QUERY = "SEARCH_RESET_ACTIVE_EXPANDED_QUERY";
export const SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING = "SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING";

// Search Security
export const SEARCH_SET_QUERY_OBFUSCATION = "SEARCH_SET_QUERY_OBFUSCATION";

// Create/Edit/Clone Search Modal
export const SEARCH_UPDATE_CREATE_SEARCH_QUERY = "SEARCH_UPDATE_CREATE_SEARCH_QUERY";
export const SEARCH_UPDATE_CREATE_SEARCH_NAME = "SEARCH_UPDATE_CREATE_SEARCH_NAME";
export const SEARCH_UPDATE_CREATE_SEARCH_TIME = "SEARCH_UPDATE_CREATE_SEARCH_TIME";
export const SEARCH_UPDATE_CREATE_SEARCH_LANGUAGE = "SEARCH_UPDATE_CREATE_SEARCH_LANGUAGE";
export const SEARCH_UPDATE_CREATE_SEARCH_LOCATION = "SEARCH_UPDATE_CREATE_SEARCH_LOCATION";

// Active Search Mangement
export const SEARCH_RESET_SEARCH_INPUT = "SEARCH_RESET_SEARCH_INPUT";
export const SEARCH_SET_SEARCH_INPUT = "SEARCH_SET_SEARCH_INPUT";
export const SEARCH_UPDATE_SEARCH_INPUT = "SEARCH_UPDATE_SEARCH_INPUT";
export const SEARCH_UPDATE_TIME_END = "SEARCH_UPDATE_TIME_END";
export const SEARCH_UPDATE_TIME_START = "SEARCH_UPDATE_TIME_START";
export const SEARCH_ZOOM_COMPLETE = "SEARCH_ZOOM_COMPLETE";
export const SEARCH_SET_SEARCH_NAME = "SEARCH_SET_SEARCH_NAME";
export const SEARCH_SET_ACTIVE_SEARCH = "SEARCH_SET_ACTIVE_SEARCH";
export const SEARCH_RESET_ACTIVE_SEARCH = "SEARCH_RESET_ACTIVE_SEARCH";

// Saved Search Management
export const SEARCH_SET_SEARCH_SIDEBAR_OPEN = "SEARCH_SET_SEARCH_SIDEBAR_OPEN";
export const SEARCH_SAVE_USER_SEARCH_SUCCESS = "SEARCH_SAVE_USER_SEARCH_SUCCESS";
export const SEARCH_SAVE_USER_SEARCH_SPINNER = "SEARCH_SAVE_USER_SEARCH_SPINNER";
export const SEARCH_SAVE_USER_SEARCH_ERROR = "SEARCH_SAVE_USER_SEARCH_ERROR";
export const SEARCH_OPEN_CREATE_SEARCH_MODAL = "SEARCH_OPEN_CREATE_SEARCH_MODAL";
export const SEARCH_CLOSE_CREATE_SEARCH_MODAL = "SEARCH_CLOSE_CREATE_SEARCH_MODAL";
export const SEARCH_OPEN_DELETE_SEARCH_MODAL = "SEARCH_OPEN_DELETE_SEARCH_MODAL";
export const SEARCH_CLOSE_DELETE_SEARCH_MODAL = "SEARCH_CLOSE_DELETE_SEARCH_MODAL";
export const SEARCH_ADD_USER_CREATED_SEARCH = "SEARCH_ADD_USER_CREATED_SEARCH";
export const SEARCH_PROACTIVELY_DELETE_USER_CREATED_SEARCH = "SEARCH_PROACTIVELY_DELETE_USER_CREATED_SEARCH";
export const SEARCH_RECEIVE_USER_SEARCHES = "SEARCH_RECEIVE_USER_SEARCHES";
export const SEARCH_RECEIVE_SEARCH_LIST = "SEARCH_RECEIVE_SEARCH_LIST";

// Filters
export const SEARCH_FILTER_CLICK = "SEARCH_FILTER_CLICK";
export const SEARCH_FILTERS_CLEAR = "SEARCH_FILTERS_CLEAR";
export const SEARCH_FILTERS_APPLY = "SEARCH_FILTERS_APPLY";
export const SEARCH_SHOW_MORE_FILTERS = "SEARCH_SHOW_MORE_FILTERS";
export const SEARCH_FETCHING_FILTERS = "SEARCH_FETCHING_FILTERS";
export const SEARCH_RECEIVE_FILTERS = "SEARCH_RECEIVE_FILTERS";
export const SEARCH_RECEIVE_FILTERS_ERROR = "SEARCH_RECEIVE_FILTERS_ERROR";
export const SEARCH_RECEIVE_FILTERS_RETRY = "SEARCH_RECEIVE_FILTERS_RETRY";
export const SEARCH_UPDATE_FILTERS = "SEARCH_UPDATE_FILTERS";
export const SEARCH_FETCHING_DYNAMIC_FILTERS = "SEARCH_FETCHING_DYNAMIC_FILTERS";
export const SEARCH_RECEIVE_DYNAMIC_FILTERS = "SEARCH_RECEIVE_DYNAMIC_FILTERS";
export const SEARCH_RECEIVE_DYNAMIC_FILTERS_ERROR = "SEARCH_RECEIVE_DYNAMIC_FILTERS_ERROR";
export const SEARCH_FETCHING_ENTITY_FILTERS = "SEARCH_FETCHING_ENTITY_FILTERS";
export const SEARCH_RECEIVE_ENTITY_FILTERS = "SEARCH_RECEIVE_ENTITY_FILTERS";
export const SEARCH_RECEIVE_ENTITY_FILTERS_ERROR = "SEARCH_RECEIVE_ENTITY_FILTERS_ERROR";
export const SEARCH_RECEIVE_ENTITY_FILTERS_RETRY = "SEARCH_RECEIVE_ENTITY_FILTERS_RETRY";
export const SEARCH_ADD_FILTERS_IMMEDIATE = "SEARCH_ADD_FILTERS_IMMEDIATE";
export const SEARCH_REMOVE_FILTERS_IMMEDIATE = "SEARCH_REMOVE_FILTERS_IMMEDIATE";
export const SEARCH_SET_ENTITY_TYPE = "SEARCH_SET_ENTITY_TYPE";
export const SEARCH_SET_FILTER_SIDEBAR_OPEN = "SEARCH_SET_FILTER_SIDEBAR_OPEN";
export const SEARCH_SET_FILTER_LIST_OPEN = "SEARCH_SET_FILTER_LIST_OPEN";
export const SEARCH_SET_FILTER_FILTER_STRING = "SEARCH_SET_FILTER_FILTER_STRING";
export const SEARCH_SET_PENDING_FILTER_FILTER_STRING = "SEARCH_SET_PENDING_FILTER_FILTER_STRING";
export const SEARCH_SET_SAVED_FILTERS_OPEN = "SEARCH_SET_SAVED_FILTERS_OPEN";

// Multi-state
export const SEARCH_HYDRATE_STATE = "SEARCH_HYDRATE_STATE";
export const SEARCH_CANCEL_ALL_CHANGES = "SEARCH_CANCEL_ALL_CHANGES";

// Searches in Timeline Graph
export const SEARCH_SELECT_SEARCH_TO_ADD_TO_GRAPH = "SEARCH_SELECT_SEARCH_TO_ADD_TO_GRAPH"

// Query Builder
export const SEARCH_SET_QUERY_BUILDER_SEARCH_INPUT = "SEARCH_SET_QUERY_BUILDER_SEARCH_INPUT";
export const OPEN_QUERY_BUILDER = "OPEN_QUERY_BUILDER";